<template>
  <div class="websites">
    <h1>Siti</h1>
    <div v-if="websites && websites.length > 0" class="table-wrap">
      <div>
        <router-link v-bind:to="{ name: 'NewWebsite' }" class="">Nuovo sito</router-link>
      </div>
      <div class="table-responsive">
          <table>
            <tr>
              <td width="">Nome</td>
              <td width="">Sito</td>
              <td width="">Regola</td>
              <td width="">Errore</td>
              <td width="">Nascosto</td>
              <td width="">Report</td>
              <td width="200" align="center">Azioni</td>
            </tr>
            <tr v-for="website in websites" v-bind:key="website">
              <td>{{ website.name }}</td>
              <td style="word-break: break-all;">{{ website.baseurl }}</td>
              <td style="word-break: break-all;">{{ website.rule }}</td>
              <td>
                  <span class="badge badge-danger" v-if="website.error">Errore</span>
              </td>
              <td>
                  <span class="badge badge-danger" v-if="website.hidereport">X</span>
              </td>
              <td>
                  <span class="badge badge-danger" v-if="website.competitorsreport">X</span>
              </td>
              <td align="center">
                <router-link v-bind:to="{ name: 'EditWebsite', params: { id: website._id } }">Modifica</router-link> |
                <a href="#" @click="deleteWebsite(website._id)">Elimina</a> |
                <router-link v-bind:to="{ name: 'WebsiteProducts', params: { id: website._id } }">Visualizza prodotti</router-link>
              </td>
            </tr>
          </table>
      </div>
    </div>
    <div v-else>
      Non ci sono ancora siti.. Creane uno nuovo!<br /><br />
      <router-link v-bind:to="{ name: 'NewWebsite' }" class="add_link">Nuovo sito</router-link>
    </div>
  </div>
</template>

<script>
import WebsitesService from '@/services/WebsitesService'
export default {
  name: 'Websites',
  data () {
    return {
      websites: []
    }
  },
  mounted () {
    this.getWebsites()
  },
  methods: {
    async getWebsites () {
      const response = await WebsitesService.fetch()
      this.websites = response.data.websites
    },
    async deleteWebsite (id) {
      await WebsitesService.delete(id)
      const response = await WebsitesService.fetch()
      this.websites = response.data.websites
      this.$router.push({ name: 'Websites' })
    }
  }
}
</script>
<style type="text/css">
.table-wrap {
  /*width: 80%;
  margin: 0 auto;*/
  text-align: center;
}
table {
  /*width: 100%;*/
}
table th, table tr {
  text-align: left;
}
table thead {
  background: #f2f2f2;
}
table tr td {
  padding: 10px;
}
table tr:nth-child(odd) {
  background: #f2f2f2;
}
table tr:nth-child(1) {
  background: #4d7ef7;
  color: #fff;
}
a {
  color: #4d7ef7;
  text-decoration: none;
}
a.add_link {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Websites.vue